import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import {
  AddCompany,
  GetCompaniesResponse,
  GetCompanyByIdResponse,
  UpdateCompanyResponse,
} from '../entities/company.entity';
import { ApiQueryParams } from '@utils/api-query-params.type';

@Injectable()
export abstract class CompanyServices {
  /**
   * All Companies
   */
  abstract getAllCompanies(
    query: ApiQueryParams
  ): Observable<GetCompaniesResponse>;

  /**
   * All Companies
   */
  abstract getCompanyById(
    companyId: string | undefined
  ): Observable<GetCompanyByIdResponse>;

  /**
   * Update Company
   */
  abstract updateCompany(
    companyId: string,
    company: any
  ): Observable<UpdateCompanyResponse>;

  /**
   * Remove member
   */
  abstract removeMember(memberId: any): Observable<any>;

  /**
   * Get Member By Id
   */
  abstract getMemberById(memberId: string | undefined): Observable<any>;

  /**
   * Delete Company
   */
  abstract deleteCompany(companyId: string | undefined): Observable<any>;

  /**
   * Delete Company
   */
  abstract sendInvoice(companyId: string | undefined): Observable<any>;

  /**
   * Payment History
   */
  abstract paymentHistory(companyId: string): Observable<any>;

  /**
   * Add Company
   */
  abstract addCompany(company: AddCompany): Observable<any>;

  /**
   * Approver By Company ID
   */
  abstract getApproverByCompanyId(companyId: string): Observable<any>;

  /**
   * Contact Company
   */
  abstract contactCompany(companyId: string): Observable<any>;

  /**
   * Validate Company Name
   */
  abstract validateCompany(companyName: string): Observable<any>;
}
